<script setup lang="ts">
import { useUiStore } from '@/stores/ui';
import ToastItem from './ToastItem.vue';

const uiStore = useUiStore();
</script>

<template>
    <Teleport to="body">
        <div
            data-slot="toast-viewport"
            class="toast-viewport"
            aria-label="Notifications"
        >
            <TransitionGroup name="toast">
                <ToastItem
                    v-for="toast in uiStore.toasts"
                    :key="toast.id"
                    :toast="toast"
                    @dismiss="uiStore.removeToast($event)"
                />
            </TransitionGroup>
        </div>
    </Teleport>
</template>
